import { applyMiddleware, createStore } from 'redux';
import { fromJS } from 'immutable';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import {composeWithDevToolsDevelopmentOnly} from '@redux-devtools/extension';

import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';

// Reducers
import { createTransform, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './data/reducer';

const isDebuggingInChrome = process.env.NODE_ENV === 'development' && !!window.navigator.userAgent;

const logger = createLogger({
    predicate: () => isDebuggingInChrome,
    stateTransformer: data => fromJS(data).toJS(),
    collapsed: true,
    duration: true
});

const persistStoreTransform = createTransform(null, (outboundState, key) => {
    const outboundStateModified = Object.assign({}, outboundState);
    console.log('outboundstate modified ', outboundStateModified, ' key ', key);
    if (key === 'settings') {
        return fromJS(outboundStateModified);
    }

    if (key === 'app') {
        return fromJS(outboundStateModified).set('invitationAccepted', null);
    }

    if (key === 'auth') {
        return fromJS(outboundStateModified)
            .set('isLoading', false)
            .set('isAuthorized', false);
    }
    return outboundStateModified;
});

const persistConfig = {
    transforms: [persistStoreTransform],
    blacklist: ['users', 'homes', 'meters', 'deviceTypes', 'training', 'devices', 'monitoring', 'reports', 'switches'],
    key:
        process.env.NODE_ENV !== 'development'
            ? 'watt-analytics-prod-persist-23-04-0833'
            : 'watt-analytics-dev-persist-23-01-0749',
    storage
};

const history = createBrowserHistory();

const rootReducerInitialized = rootReducer(history);
console.log('rootReducerInitialized', rootReducerInitialized);
export const persistedReducer = persistReducer(persistConfig, rootReducerInitialized);

/*
 * Returns store (redux state & dispatcher) with persistor for AsyncStorage
 * - NOTE: This was changed rapidly in redux-persist v5
 * - More info here: https://github.com/rt2zz/redux-persist#migration-from-v4-to-v5
 * @param {Function} callback
 *   - Callback should always be action (so it can be dispatched)
 * @return {Object} with keys store and persistor
 * */
const configureStore = callback =>
    // eslint-disable-next-line
    new Promise((resolve, reject) => {
        try {
            const store = createStore(
                persistedReducer,
                composeWithDevToolsDevelopmentOnly(
                    applyMiddleware(
                        routerMiddleware(history), // for dispatching history actions
                        thunk,
                        logger
                    )
                )
            );

            if (isDebuggingInChrome) {
                window.store = store;
            }

            persistStore(store, {}, () => {
                if (callback) callback({ store, history });
                resolve();
            });
        } catch (e) {
            reject(e);
        }
    });
export default configureStore;
